import { projectCatalogMemoryEnabled as clientEnvHintEnabled } from "@/lib/projectCatalogMemoryFlag";
import { trpc } from "@/lib/trpc";

/**
 * Server is source of truth for Project Catalog memory (env + migration 0088).
 * Client VITE flag is a build-time hint only — surfaced in status for debugging.
 */
export function useProjectCatalogMemoryStatus() {
  const query = trpc.salesSandbox.getProjectCatalogMemoryStatus.useQuery(undefined, {
    staleTime: 60_000,
    retry: false,
  });

  const server = query.data;
  const memoryActive = Boolean(server?.memoryActive);
  const lookupReady = Boolean(server?.lookupReady);

  return {
    isLoading: query.isLoading,
    isError: query.isError,
    memoryActive,
    lookupReady,
    serverEnvEnabled: server?.serverEnvEnabled ?? false,
    schemaReady: server?.schemaReady ?? false,
    clientEnvHintEnabled,
    message:
      server?.message ??
      (query.isError
        ? "Could not check Project Catalog memory status — changes apply to this session only."
        : "Checking Project Catalog memory…"),
    status: server,
    refetch: query.refetch,
  };
}
